module.exports = __webpack_public_path__ + "static/img/danshuiyichang.7352716.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/danshuiyichang.jpg
// module id = l8ZH
// module chunks = 1